import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import * as Types from './types';
import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import { IGNORE_LIMITS_NOTIFICATION } from '../../constants';

export const useGetPlayerRealityCheck = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IPlayerRealityCheckResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IPlayerRealityCheckResponseData>({
            ID: 89913,
            responses: [89914, 89900],
            description: 'Get Player Reality Check',
            correlationId: uniqueId(`${IGNORE_LIMITS_NOTIFICATION}-`)
        });

        return data;
    }, [send]);
};
